import { useEffect, useRef, useState } from "react";
import apiInstance from "../../../apiInstance";
import UserDetails from "./UserDetails";
import PaymentMethods from "./PaymentMethods";
import UserPayments from "./UserPayments";
import PopupModal from "../../Popups/PopupModal";
import UserSubscriptions from "./UserSubscriptions";
import { useNavigate, useParams } from "react-router-dom";
import Button from "../../../Button";

const DetailsPage = () => {

    const { userId } = useParams();
    const [userDetails, setUserDetails] = useState({});
    const [paymentMethods, setPaymentMethods] = useState({});
    const [payments, setPayments] = useState({});
    const [subscriptions, setSubscriptions] = useState({});
    const [error, setError] = useState("");
    const popupRef = useRef();
    const navigate = useNavigate();

    const updateUserHandler = (user) => {
        setUserDetails(user);
    }

    const deleteUserHandler = () => navigate("/devadmin/users");

    const deletePaymenMethodHandler = (id) => setPaymentMethods((prev) => prev.filter(item => item._id !== id))

    const deletePaymentHandler = (paymentId) => {
		setPayments((prev) => prev.filter(item => item.id !== paymentId));
    }

    const updatePaymentHandler = (payment) => {
        const updatedPayments = payments.map(item => item.id === payment.id ? {...item, ...payment} : item);
        setPayments(updatedPayments)
    }

    const deleteSubscriptionHandler = (id) => {
		setSubscriptions((prev) => prev.filter(item => item.id !== id));
    }

    const updateSubscriptionsHandler = (sub) => {
        const updatedSubs = subscriptions.map(item => item.id === sub.id ? {...item, ...sub} : item);
        setSubscriptions(updatedSubs)
    }

    useEffect(() => {
        const fetchUserDetails = async () => {
            apiInstance
                .get(`/devadmin/user/${userId}`)
                .then((response) => {
                    setUserDetails(response.data.user?.userDetails || {});                    
                    setPaymentMethods(response.data.user?.paymentMethods || []);                    
                    setPayments(response.data.user?.payments || []);                    
                    setSubscriptions(response.data.user?.subscriptions || []);                    
                })
                .catch((error) => {
                    console.error("Error fetching data:", error);
                    setError("Failed to load user details.");
                });
        }
        fetchUserDetails();
    }, [userId])

    return (
        <div className="mjsdev-dtl-page">
            <div className="mjsdev-dtl-header">
                <button className="mjsdev-dtl-back-btn mjs-btn" onClick={() => navigate("/devadmin/users")}>All Users</button>
                <div>
                    <button 
                        className="mjs-btn"
                         onClick={(e) => {
                            if (popupRef.current) {
                                popupRef.current.openPopup(
                                    "editUser",
                                    { user: userDetails }
                                );
                            }
                        }}
                    >Edit</button>
                    <button 
                        className="mjs-btn"
                        onClick={(e) => {
                            e.stopPropagation();
                            if (popupRef.current) {
                                popupRef.current.openPopup(
                                    "deleteUser",
                                    { userId }
                                );
                            }
                        }}
                    >Delete</button>
                </div>
            </div>

            <div className="mjs-error">{error}</div>

            <UserDetails
                userDetails={userDetails}
            />
            <PaymentMethods
                paymentMethods={paymentMethods}
                handleDelete={deletePaymenMethodHandler}
            />
            <UserSubscriptions 
                subscriptions={subscriptions}
                onEdit={(sub) => {
                    popupRef.current?.openPopup("editSubscription", { subscription: sub });
                }}
                onDelete={(subId) => {
                    popupRef.current?.openPopup("deleteSubscription", { subId: subId });
                }}
            />
            <UserPayments 
                payments={payments}
                onEdit={(payment) => {
                    popupRef.current?.openPopup("editPayment", { payment });
                }}
                onDelete={(paymentId) => {
                    popupRef.current?.openPopup("deletePayment", { paymentId });
                }}
            />
            <PopupModal
                ref={popupRef}
                updateUser={updateUserHandler}
                deleteUser={deleteUserHandler}
                deletePayment={deletePaymentHandler}
                updatePayment={updatePaymentHandler}
                deleteSubscription={deleteSubscriptionHandler}
                updateSubscription={updateSubscriptionsHandler}
            />
        </div>
    );
};

export default DetailsPage;
